import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import {
  RadioField,
  DateRadioField,
  SliderField,
  SelectField,
  required,
  number,
  includedIn,
  minValue,
  maxValue
} from '../../form';


class EmailTemplateSettings extends Component {
  onFormSubmit(values) {
    const { dispatch, emailTemplate, website } = this.props;

    dispatch(setLoader('ETemplateSettingsForm'));
    dispatch(PublisherApi.actions.emailTemplateUpdate.post(emailTemplate.uuid, values, (error, success) => {
      dispatch(removeLoader('ETemplateSettingsForm'));
      if (success) {
        dispatch({
          type: PublisherApi.events.emailTemplate.actionSuccess,
          syncing: false,
          data: { data: { ...success.data } }
        });

        dispatch(PublisherApi.actions.pixel.get({ publisher_website_id: website.uuid }));
      }
    }));
  }

  render() {
    const { handleSubmit, isLoading, emailTemplateFormValues } = this.props;

    return (
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >
          <Field
            name='email_template[custom]'
            label="Template Type"
            options={[[true, 'Custom'], [false, 'Builder']]}
            defaultValue={false}
            component={RadioField}
            parse={val => val === 'true'}
          />

          <Field
            name='email_template[title_length]'
            label='Title Length'
            minValue={10}
            maxValue={60}
            unit="chr"
            component={SliderField}
            validate={[required, number, minValue(10), maxValue(60)]}
          />

          <Field
            name='email_template[desc_length]'
            label='Description Length'
            minValue={10}
            maxValue={300}
            unit="chr"
            component={SliderField}
            validate={[required, number, minValue(10), maxValue(300)]}
          />

          <Field
            name='email_template[date_format]'
            label="Date Format"
            options={[
              ['relative', 'Relative'], 
              ['long', 'MMM, DD, YYYY'], 
              ['iso8601', 'YYYY/MM/DD'], 
              ['MM/DD/YYYY', 'MM/DD/YYYY'], 
              ['MM/DD/YY', 'MM/DD/YY']
            ]}
            component={DateRadioField}
            validate={[required, includedIn(['relative', 'long', 'iso8601', 'MM/DD/YYYY', 'MM/DD/YY', 'DD/MM/YYYY'])]}
          />

          <Field
            type='text'
            name='email_template[slots]'
            placeholder='Number of slots'
            label='Slots'
            component={SelectField}
            options={[
              { label: '1', value: 1 },
              { label: '2', value: 2 },
              { label: '3', value: 3 },
              { label: '4', value: 4 },
              { label: '5', value: 5 }
            ]}
            normalize={(e) => e.value}
            validate={[required, number, minValue(1), maxValue(5)]}
          />

          { emailTemplateFormValues && emailTemplateFormValues.email_template.custom ? (
            <Field
              name='email_template[custom_pixel_slot_height]'
              label='Custom Pixel Slot Height'
              minValue={10}
              maxValue={400}
              unit="px"
              component={SliderField}
              validate={[required, number, minValue(10), maxValue(400)]}
            />
          ) : (
            <Field
              name='email_template[builder_pixel_slot_height]'
              label='Builder Pixel Slot Height'
              minValue={50}
              maxValue={200}
              unit="px"
              component={SliderField}
              validate={[required, number, minValue(50), maxValue(200)]}
            />
          )}

          <br />


          <Button
            type='submit'
            loading={isLoading}
            bsStyle='primary'
          >
            Update
          </Button>
        </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'ETemplateSettingsForm',
  enableReinitialize: true
});

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const { emailTemplate } = ownProps;

  const initialValues = {
    email_template: {
      desc_length: emailTemplate.desc_length,
      title_length: emailTemplate.title_length,
      date_format: emailTemplate.date_format,
      slots: emailTemplate.slots,
      custom: emailTemplate.custom,
      custom_pixel_slot_height: emailTemplate.custom_pixel_slot_height,
      builder_pixel_slot_height: emailTemplate.builder_pixel_slot_height
    }
  };

  const isLoading = loader.includes('ETemplateSettingsForm');

  const emailTemplateFormValues = getFormValues('ETemplateSettingsForm')(state);

  return { isLoading, initialValues, emailTemplateFormValues };
};

export default connect(mapStateToProps)(ResourceForm(EmailTemplateSettings));
